// use "responsive" backgroundimages
// HTML-Markup see for example udg_package/Resources/Private/Templates/udg_ce_grid/Grid.html
export default function () {
    const $elementsWithBgimages = $('.responsive-bgimages');

    if ($elementsWithBgimages.length < 1) {
        return;
    }

    function replaceBackground() {
        const viewportWidth = window.innerWidth;

        $elementsWithBgimages.each((index, element) => {
            const $element = $(element);
            let bgimage = '';

            if (viewportWidth < 768) {
                bgimage = $element.data('bgimage-xs');
                $element.css('background-image', 'url("' + bgimage + '")');
                return;
            }
            if (viewportWidth < 1024) {
                bgimage = $element.data('bgimage-sm');
                $element.css('background-image', 'url("' + bgimage + '")');
                return;
            }
            if (viewportWidth < 1160) {
                bgimage = $element.data('bgimage-md');
                $element.css('background-image', 'url("' + bgimage + '")');
                return;
            }

            bgimage = $element.data('bgimage-lg');
            $element.css('background-image', 'url("' + bgimage + '")');
        });
    }

    // set bgimages on initial loading
    replaceBackground();
    // replace bgimages when user rotates device
    window.addEventListener('orientationchange', replaceBackground, { passive: true });
}
